import OSS from "ali-oss";
import { RayKeyClient } from './rayKeyClient';
const getOSSClient = async (region = "oss-cn-hangzhou", name = "ray-common") => {
  const apiDomain = "https://api.rayteams.com.cn";
  const apiUri = "/gc";
  const rayKeyClient = new RayKeyClient(apiDomain, apiUri);
  const credentials = await rayKeyClient.CallApi({});
  const ossClient = new OSS({
    accessKeyId: credentials.AccessKeyId,
    accessKeySecret: credentials.AccessKeySecret,
    stsToken: credentials.SecurityToken,
    region: region,
    bucket: name,
    timeout: 120000,
    retryMax: 3,
  });
  return ossClient;
};

export default getOSSClient;